import crypto from 'crypto'

class Decryption {
  getKey(buffer, key) {
    const hmacInstance = crypto.createHmac('sha256', key)
    return hmacInstance.update(buffer).digest()
  }

  computeSymmetricEncryption(iv, cipherText, key) {
    const cipher = crypto.createCipheriv('aes-256-ctr', key, iv)
    cipher.setAutoPadding(false)
    return Buffer.concat([cipher.update(cipherText), cipher.final()])
  }

  computeHMAC(key, iv, cipherText) {
    const hmacInstance = crypto.createHmac('sha256', key)
    const hmac = hmacInstance
      .update(iv)
      .update(cipherText)
      .digest()
    return Buffer.from(hmac).slice(0, 16)
  }

  decrypt(base64URlDecoded, hmacSecretKey, encryptionKey) {
    const hmac = base64URlDecoded.slice(0, 16)
    const iv = base64URlDecoded.slice(16, 32)
    const encryptedData = base64URlDecoded.slice(32)
    const expectedHMAC = this.computeHMAC(hmacSecretKey, iv, encryptedData)

    if (expectedHMAC.equals(hmac)) {
      return this.computeSymmetricEncryption(iv, encryptedData, encryptionKey)
    }
    throw new Error(400, 'Invalid sdp data')
  }

  decodeAndDecrypt(sdpData, key) {
    try {
      const sdpKey = Buffer.from(key, 'hex')
      const derivedEncryptionKey = Buffer.from(this.getKey(Buffer.from([0x00]), sdpKey))
      const derivedHMACKey = Buffer.from(this.getKey(Buffer.from([0x01]), sdpKey))
      const decrypted = this.decrypt(Buffer.from(sdpData, 'base64'), derivedHMACKey, derivedEncryptionKey)
      return decrypted
    } catch (error) {
      console.error(500, 'Decryption process failed')
      return null
    }
  }

  encrypt(data, hmacSecretKey, encryptionKey, iv) {
    const cipher = crypto.createCipheriv('aes-256-ctr', encryptionKey, iv)
    cipher.setAutoPadding(false)
    const encrypted = Buffer.concat([cipher.update(data), cipher.final()])
    const hmac = this.computeHMAC(hmacSecretKey, iv, encrypted)
    return Buffer.concat([hmac, iv, encrypted])
  }

  encodeAndEncrypt(data, key) {
    try {
      const sdpKey = Buffer.from(key, 'hex')
      const derivedEncryptionKey = Buffer.from(this.getKey(Buffer.from([0x00]), sdpKey))
      const derivedHMACKey = Buffer.from(this.getKey(Buffer.from([0x01]), sdpKey))
      const iv = this.createFixedIV(key)
      const encrypted = this.encrypt(data, derivedHMACKey, derivedEncryptionKey, iv)
      return encrypted
        .toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
    } catch (error) {
      console.error(500, 'Encryption process failed')
      return null
    }
  }

  createFixedIV(key) {
    const sdpKey = Buffer.from(key, 'hex')
    const hash = crypto
      .createHash('sha256')
      .update(sdpKey)
      .digest()
    return hash.slice(0, 16)
  }
}

export default new Decryption()
